import { cn } from "@/lib/utils";
import { Text } from "components/core/Text";
import { ComponentProps } from "react";

export const ContentTags = ({
    tags,
    color,
    className,
    ...props
}: {
    tags: Mix_ContentFragment["mix_content_tags"];
    color?: ComponentProps<typeof Text>["color"];
    className?: string;
}) => {
    return (
        <div
            className={cn("flex items-center overflow-hidden", className)}
            {...props}
        >
            {tags.map((tag) => (
                <Text
                    key={tag.mix_content_tag_enum.value}
                    variant="body4"
                    color={color || "primary.dark"}
                    className="[&:not(:last-child)]:after:mx-1
                        [&:not(:last-child)]:after:content-['·']"
                >
                    {tag.mix_content_tag_enum.comment}
                </Text>
            ))}
        </div>
    );
};
